import { ScreeningStatusForPositionInput } from "~/graphql/supergraphTypes";
import { PositionsTableRowItem } from "../types";

export const buildScreeningStatusReportInput = (
  selectedRows: PositionsTableRowItem[],
): ScreeningStatusForPositionInput[] => {
  return selectedRows.map((row) => {
    // If position doesn't have an onboarding case, send additional client-side data
    // (accountName, entityName, programName) to avoid an extra backend API call.
    if (row.onboardingStatus === null) {
      return {
        accountName: row.investingAccount,
        entityName: row.entity?.name,
        positionId: String(row.id),
        programName: row.program?.[0],
      };
    }
    return {
      positionId: String(row.id),
    };
  });
};
